/* eslint-disable camelcase */
import { OidcConfiguration } from '@axa-fr/react-oidc';

export const configurationIdentityServer: OidcConfiguration = {
    client_id: import.meta.env.VITE_APP_OIDC_CLIENT_ID,
    redirect_uri: `${window.location.origin}/authentication/callback`,
    silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`, // Optional activate silent-signin that use cookies between OIDC server and client javascript to restore the session
    scope: 'openid profile roles email welcome.doka.com/onboarding notifications.doka.com/notifications.inbox',
    authority: import.meta.env.VITE_APP_OIDC_AUTHORITY,
    preload_user_info: true,
};
